{
	"title": "Flashcards",
	"subtitle": "{sets, plural, one {# set} other {# sets}} · {total, plural, one {# card} other {# cards}} · {due} due today",
	"generate": {
		"cta": "Generate",
		"title": "Generate flashcards",
		"description": "From a material via AI. Results are editable.",
		"source": "Source",
		"sourceMaterial": "From material",
		"sourceTopic": "Standalone topic",
		"materialPicker": "Material",
		"materialPlaceholder": "Pick a material...",
		"topicLabel": "Topic",
		"topicPlaceholder": "Krebs cycle. Link to aerobic glycolysis...",
		"nameLabel": "Set name (optional)",
		"namePlaceholder": "Auto-filled from material",
		"typesLabel": "Card types",
		"countLabel": "Card count",
		"languageLabel": "Generation language",
		"languageHint": "We consider material language and your UI language",
		"submit": "Generate",
		"cancel": "Cancel",
		"quotaTitle": "Flashcard AI generation",
		"quotaUsage": "{used} of {limit} this month",
		"quotaReset": "Resets {date}",
		"quotaUpsell": "Learn about Plus",
		"streamingTitle": "Creating set...",
		"streamingStage": "Stage: {stage}",
		"streamingProgress": "{done} of {total} ready",
		"closeAndKeep": "Close & continue in background",
		"openSet": "Open set",
		"successTitle": "Done! {count, plural, one {# flashcard generated} other {# flashcards generated}}",
		"createAnother": "Create another",
		"hintAudio": "Audio-term: TTS adds ~30 sec",
		"hintImage": "Image-term: recognize images from material",
		"materialLoading": "Loading…",
		"materialPagesShort": "{count} p.",
		"materialMinutesShort": "{count} min"
	},
	"library": {
		"newSet": "Create",
		"setCta": "Create empty",
		"createSet": "Create empty",
		"createSetTitle": "Create empty",
		"setNamePlaceholder": "Biology — exam prep",
		"colorLabel": "Color",
		"colorPickerAria": "Color {color}",
		"kpi": {
			"due": "due today",
			"new": "new",
			"total": "learned",
			"accuracy": "accuracy"
		},
		"filters": {
			"material": "Material",
			"tag": "Tag",
			"sort": "Sort",
			"sortUpdated": "Updated",
			"sortDue": "Due",
			"sortAccuracy": "Accuracy",
			"view": "View",
			"viewGrid": "Grid",
			"viewTable": "Table",
			"search": "Search sets...",
			"searchBookmarks": "Search bookmarks..."
		},
		"searchEmpty": {
			"title": "Nothing found",
			"subtitle": "No sets match “{query}”. Try a different query or filter."
		},
		"card": {
			"cardCount": "{count, plural, one {# card} other {# cards}}",
			"dueToday": "due today",
			"noDue": "Nothing due",
			"studyCta": "Study",
			"continueCta": "Continue",
			"mastered": "{pct}% mastered",
			"fromMaterial": "From material “{name}”",
			"fromChat": "From chat “{name}”"
		},
		"empty": {
			"title": "No flashcard sets yet.",
			"subtitle": "Generate from a material or create manually.",
			"generate": "Generate from material",
			"create": "Create empty"
		},
		"markedPreview": {
			"title": "Bookmarks",
			"openAll": "Open all",
			"emptyHint": "Cards you bookmark during a session will appear here."
		},
		"tabs": {
			"aria": "Sets or bookmarks",
			"sets": "Sets",
			"bookmarks": "Bookmarks"
		},
		"bookmarks": {
			"count": "{total, plural, one {# bookmarked card} other {# bookmarked cards}}",
			"studyAll": "Study all ({n})",
			"manage": "All bookmarks",
			"emptyTitle": "No bookmarks yet.",
			"emptyHint": "During a review session, tap the bookmark or press M — the card lands here.",
			"searchEmptyTitle": "Nothing found",
			"searchEmptyHint": "No bookmarked cards match this query. Try a different search or clear the filter."
		},
		"streaming": {
			"label": "Generating...",
			"stage": "Stage: {stage}",
			"failed": "Generation failed",
			"retry": "Retry"
		},
		"menu": {
			"title": "Actions",
			"rename": "Rename",
			"color": "Change color",
			"delete": "Delete",
			"export": "Export CSV",
			"editCards": "Edit cards"
		},
		"renameDialog": {
			"title": "Rename set",
			"placeholder": "Set name",
			"submit": "Save",
			"success": "Set renamed",
			"error": "Couldn't rename"
		},
		"colorDialog": {
			"title": "Change color",
			"submit": "Save",
			"success": "Color updated"
		},
		"deleteDialog": {
			"title": "Delete set \"{name}\"?",
			"description": "The set and its cards will move to trash for 30 days.",
			"submit": "Move to trash",
			"cancel": "Cancel",
			"success": "Set moved to trash",
			"error": "Couldn't delete"
		},
		"relativeTime": {
			"minutesAgo": "{count, plural, one {# min} other {# min}} ago",
			"hoursAgo": "{count, plural, one {# h} other {# h}} ago",
			"daysAgo": "{count, plural, one {# d} other {# d}} ago",
			"justNow": "just now"
		},
		"stages": {
			"queued": "Queued",
			"retrieving": "Retrieving context",
			"generating": "Generating cards",
			"tts-batching": "Voice synthesis",
			"persisting": "Saving",
			"done": "Done"
		},
		"errorTitle": "Failed to load",
		"errorSubtitle": "Something went wrong. Try again.",
		"retry": "Retry"
	},
	"setDetail": {
		"back": "Back",
		"studyCta": "Study {due}",
		"menu": {
			"rename": "Rename",
			"color": "Change color",
			"delete": "Delete",
			"exportCsv": "Export CSV",
			"regenerate": "Generate more",
			"openMaterial": "Open source"
		},
		"subtitle": "{total, plural, one {# card} other {# cards}} · {due} due · {new} new · {mastery}% mastered",
		"stats": {
			"learned": "Learned",
			"review": "Review",
			"new": "New",
			"marked": "Bookmarked",
			"averageEf": "Avg EF: {ef}",
			"retention": "Long-term retention: {pct}%"
		},
		"toolbar": {
			"addCard": "Card",
			"generate": "Generate more",
			"reorder": "Reorder",
			"import": "Import",
			"type": "Type",
			"srs": "SRS",
			"marked": "Bookmarks",
			"search": "Search..."
		},
		"srsState": {
			"new": "New",
			"learning": "Learn.",
			"review": "Reviw",
			"relearning": "Relrn",
			"suspended": "Susp",
			"buried": "Bury",
			"all": "All states"
		},
		"cardTypeLabel": {
			"all": "All types",
			"term-definition": "T-D",
			"fill-blank": "Fill",
			"multiple-choice": "MCQ",
			"audio-term": "Audio",
			"image-term": "Img→T",
			"term-image": "T→Img"
		},
		"table": {
			"index": "#",
			"type": "Type",
			"front": "Front",
			"back": "Back",
			"srs": "SRS",
			"actions": "Actions"
		},
		"empty": {
			"title": "No cards in this set yet.",
			"subtitle": "Create manually, generate from material, or import CSV."
		},
		"showMore": "Show {count} more ↓",
		"deleteConfirm": {
			"title": "Delete set?",
			"body": "Set \"{name}\" and all its cards will move to trash for 30 days."
		}
	},
	"study": {
		"title": "{setName} · {mode}",
		"counter": "{current} / {total}",
		"flipHint": "Tap to flip",
		"revealCta": "Reveal answer",
		"answerLabel": "Answer",
		"sessionTitle": "Flashcard review",
		"sessionSubtitle": "Review session",
		"cardKind": {
			"term-definition": "Term & definition",
			"fill-blank": "Fill in the blank",
			"multiple-choice": "Choose the answer",
			"audio-term": "Audio & term",
			"image-term": "Image & term",
			"term-image": "Term & image"
		},
		"endSession": "End session",
		"settings": "Settings",
		"modes": {
			"srs": "SRS",
			"standard": "Standard",
			"cram": "Cram",
			"marked": "Bookmarks",
			"leitner-session": "Leitner"
		},
		"modeLabel": {
			"srs": "SRS (scheduled)",
			"standard": "Standard (in order)",
			"cram": "Cram (all, repeat until Easy)",
			"marked": "Bookmarks",
			"leitner-session": "Leitner session (1 pass)"
		},
		"interval": {
			"minutes": "{n}<10min",
			"min": "<10 min",
			"day": "{n, plural, one {# day} other {# days}}",
			"days": "{n} days"
		},
		"intervals": {
			"again": "<10 min",
			"hard": "1 day",
			"good": "3 days",
			"easy": "7 days"
		},
		"ratings": {
			"again": "Forgot",
			"hard": "Hard",
			"good": "Got it",
			"easy": "Easy"
		},
		"tour": {
			"openHelp": "How it works",
			"step1": {
				"title": "This is spaced repetition",
				"body": "Try to recall the answer → rate yourself honestly → the card comes back after an interval. The easier it feels, the longer until you see it again."
			},
			"step2": {
				"title": "4 rating buttons",
				"body": "“Forgot” — see it again in <10 min. “Hard” — 1 day. “Got it” — 3 days. “Easy” — 7 days. The interval is shown under each button."
			},
			"step3": {
				"title": "Be honest",
				"body": "If you keep tapping “Easy”, the algorithm will push the card too far out and you'll forget it. Rate yourself based on how you actually recalled."
			},
			"next": "Next",
			"back": "Back",
			"start": "Start",
			"skip": "Skip"
		},
		"confidence": {
			"title": "How confident?",
			"sure": "Sure",
			"unsure": "Unsure",
			"guess": "Guess"
		},
		"settingsSheet": {
			"title": "Session settings",
			"modeLabel": "Session mode",
			"modeHint": {
				"srs": "Only cards that are due for review according to the SRS algorithm.",
				"standard": "All cards in the set, ignoring the SRS schedule.",
				"cram": "All cards repeated until rated «Easy».",
				"marked": "Only cards you've bookmarked.",
				"leitner-session": "All cards in one pass with no repeats within the session."
			},
			"orderLabel": "Order",
			"orderSequential": "In order",
			"orderRandom": "Random",
			"orderSpaced": "Interleaved",
			"orderHint": {
				"sequential": "Cards are shown in the set's original order.",
				"random": "The deck is shuffled before start.",
				"spaced": "Cards are interleaved so similar ones don't follow each other."
			},
			"limitLabel": "Card limit",
			"limitHint": "How many cards to show in a single session.",
			"confidenceLabel": "Confidence rating before flip",
			"confidenceHint": "Ask how confident you are before revealing the answer (for metacognitive feedback).",
			"audioSectionLabel": "Sound",
			"autoAudioLabel": "Auto-play audio",
			"autoAudioHint": "Automatically play the card's audio when it appears.",
			"sfxLabel": "Sound effects",
			"sfxHint": "Short sounds for actions: flip, rate, bookmark.",
			"apply": "Save & apply"
		},
		"endDialog": {
			"title": "End session?",
			"subtitle": "You have {n} unreviewed cards.",
			"confirm": "End now",
			"cancel": "Continue"
		},
		"complete": {
			"title": "Session complete",
			"cards": "Cards studied",
			"accuracy": "Accuracy",
			"marked": "Bookmarked",
			"duration": "Duration",
			"nextDue": "Next due",
			"perfect": "🎉 Perfect score!",
			"continueMarked": "Study bookmarks",
			"backToSet": "Back to set",
			"library": "Library"
		},
		"empty": {
			"title": "All caught up!",
			"subtitle": "Nothing due in this set today.",
			"subtitleNext": "Come back tomorrow — more cards will be ready.",
			"learnNew": "Learn new",
			"openMarked": "Study bookmarks",
			"backToSet": "← Back to set",
			"toLibrary": "Back to flashcard library"
		},
		"shortcuts": {
			"flip": "Flip",
			"rate": "Rate",
			"mark": "Bookmark",
			"hint": "Hint",
			"source": "Source",
			"undo": "Undo",
			"skip": "Skip",
			"settings": "Settings",
			"end": "End",
			"navigate": "Browse"
		},
		"loading": "Preparing session...",
		"ratingQueued": "Offline — saved locally",
		"audio": {
			"play": "Play",
			"replay": "Replay"
		},
		"mcq": {
			"correct": "Correct answer",
			"youChose": "You chose"
		},
		"fillBlank": {
			"placeholder": "Type your answer..."
		},
		"card": {
			"mark": "Bookmark",
			"unmark": "Remove bookmark",
			"source": "Source",
			"hint": "Hint",
			"markFailed": "Failed to update bookmark"
		},
		"citationPageShort": "p. {page}"
	},
	"marked": {
		"title": "Bookmarks",
		"subtitle": "{total, plural, one {# card} other {# cards}} · {due} due today",
		"autoUnmarkHint": "Auto-remove from bookmarks after 3 correct in a row",
		"studyAllCta": "Study all ({n})",
		"kpi": {
			"total": "total",
			"sets": "sets"
		},
		"markCard": "Bookmark",
		"unmarkCard": "Remove bookmark",
		"markedList": "Bookmarks",
		"empty": {
			"title": "No bookmarks yet.",
			"subtitle": "During a session tap the bookmark or press M — the card will appear here.",
			"back": "Back to library"
		},
		"table": {
			"set": "Set",
			"addedAt": "Added"
		},
		"bulk": {
			"selected": "{n} selected",
			"unmark": "Unmark",
			"delete": "Delete",
			"move": "Move to set",
			"cancel": "Cancel"
		},
		"menu": {
			"unmark": "Unmark",
			"edit": "Edit",
			"move": "Move to set",
			"resetSrs": "Reset SRS",
			"delete": "Delete"
		}
	},
	"editor": {
		"newTitle": "New card",
		"editTitle": "Edit card",
		"step1Label": "Choose card type",
		"step1Hint": "Can be changed later",
		"typeNames": {
			"term-definition": "Term → Definition",
			"fill-blank": "Fill-in-blank",
			"multiple-choice": "Multiple choice",
			"audio-term": "Audio → term",
			"image-term": "Image → term",
			"term-image": "Term → image"
		},
		"fields": {
			"term": "Term (front)",
			"definition": "Definition (back)",
			"blankText": "Text with blank",
			"blankAnswer": "Answer (fill value)",
			"question": "Question",
			"options": "Options",
			"ttsText": "TTS text (pronunciation)",
			"audioTerm": "Answer (term)",
			"audioDefinition": "Definition (optional)",
			"voice": "TTS voice",
			"frontImage": "Image (front)",
			"backImage": "Image (back)",
			"caption": "Caption / name",
			"captionBack": "Caption under image (optional)",
			"termText": "Term (front)",
			"hint": "Hint (optional)",
			"tags": "Tags",
			"citation": "Source (optional)",
			"optionPlaceholder": "Option {index}"
		},
		"actions": {
			"next": "Next →",
			"cancel": "Cancel",
			"save": "Save",
			"create": "Create",
			"mark": "Mark",
			"resetSrs": "Reset SRS"
		},
		"audio": {
			"preview": "Play",
			"regenerate": "Regenerate",
			"loading": "Generating..."
		},
		"image": {
			"dropzone": "Drop or pick file",
			"hint": "PNG/JPG/WebP up to 10MB",
			"remove": "Remove",
			"open": "Open",
			"uploading": "Uploading {percent}%",
			"cancel": "Cancel",
			"errorTooLarge": "File larger than 10 MB",
			"errorUnsupported": "Supported: PNG, JPG, WebP, GIF, HEIC",
			"errorNetwork": "Upload failed — check your connection",
			"errorGeneric": "Could not upload image"
		},
		"mcq": {
			"addOption": "Add option (max 6)",
			"minOptions": "Minimum 2 options",
			"correctHint": "Mark correct option"
		},
		"fillBlank": {
			"insertBlank": "Insert blank",
			"previewLabel": "Preview"
		},
		"tagsPlaceholder": "Add a tag and press Enter",
		"citationPlaceholder": "Search in material...",
		"toast": {
			"saved": "Saved",
			"created": "Card created",
			"invalidFields": "Fill in required fields"
		}
	},
	"rating": {
		"again": "Again",
		"againHint": "Don't remember",
		"hard": "Hard",
		"hardHint": "Struggled",
		"good": "Good",
		"goodHint": "Got it",
		"easy": "Easy",
		"easyHint": "Knew instantly"
	},
	"types": {
		"termDefinition": "Term — definition",
		"fillBlank": "Fill in the blank",
		"multipleChoice": "Multiple choice",
		"audioTerm": "Audio → term",
		"imageTerm": "Image → term",
		"termImage": "Term → image"
	},
	"list": {
		"title": "All decks",
		"empty": "No flashcards",
		"create": "Create deck"
	},
	"session": {
		"start": "Start review",
		"resume": "Continue",
		"progress": "{current} of {total}",
		"remaining": "{count, plural, one {# card} other {# cards}} remaining",
		"finished": "Session complete",
		"noCardsDue": "All caught up for today"
	},
	"stats": {
		"dueToday": "{count, plural, one {# card} other {# cards}} due",
		"newCards": "New: {count}",
		"learning": "Learning: {count}",
		"reviewing": "Reviewing: {count}",
		"mastered": "Mastered: {count}"
	},
	"generation": {
		"starting": "Generating flashcards…",
		"ready": "{count, plural, one {# flashcard ready} other {# flashcards ready}}",
		"failed": "Failed to generate flashcards"
	},
	"aiDisclaimer": {
		"message": "Generated by AI. Verify accuracy before relying on it.",
		"ack": "Got it"
	},
	"mobileUx": {
		"filtersLabel": "Filters",
		"filtersTitle": "Card filters",
		"filtersApply": "Apply",
		"filtersReset": "Reset",
		"actionsTitle": "Actions",
		"cardActionsTitle": "Card actions",
		"swipeDelete": "Delete",
		"refresh": "Refresh",
		"studyCtaShort": "Study",
		"frontLabel": "Front",
		"backLabel": "Back",
		"quotaUnlimited": "Unlimited"
	},
	"intro": {
		"title": "Cards come back on their own",
		"body": "The app works out when you are about to forget a card and shows it exactly then. A test is a one-off check; cards are repetition on a schedule.",
		"bullets": [
			"Your rating sets when the card shows up next",
			"Six types, from term–definition to gaps and images",
			"A deck comes from a material, a topic or a weak spot"
		]
	}
}
